import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { OpenPickPointForm } from 'sections/PromoSection/pages/PromoPage/shared/OpenPickPointForm/OpenPickPointForm'
import { TextPromo } from 'components/ui'
import { Href } from 'components/ui/Href/Href'
import { Space } from 'components/ui/Space/Space'
import { isGeDomain } from 'utils/helpers/domains/getDomain'
import { sendEvent } from 'utils/helpers/sendEvent'
import { useResize } from 'utils/hooks/useResize'
import { URLS } from 'shared/constants/urls'
import { EventType } from 'types/types'

import { PromoPageKeys } from '../../../types'

import cls from './MapGe.module.scss'

export const MapGe: FC = () => {
  const { isTablet, isMobile } = useResize()
  const { t } = useTranslation()

  const mapLink = isGeDomain() ? URLS.pick_point_map_ge : URLS.pick_point_map

  const getKey = (key: string) => `${PromoPageKeys.map}.${key}`

  return (
    <div>
      <Space size={!isTablet ? 90 : !isMobile ? 59 : 50} />
      <div className={cls.mapSection}>
        <div className={`${cls.form} ${cls.box}`}>
          <OpenPickPointForm />
        </div>
        <div className={`${cls.map} ${cls.box}`}>
          <TextPromo size="s32" fontFamily="ASLHauss" weight="w550">
            {t(getKey('Выберите лучшее место на карте'))}
          </TextPromo>
          <Space size={16} />
          <TextPromo size="s20" fontFamily="ASLHaussVF">
            {t(getKey('Мы отметили фиолетовым цветом самые прибыльные зоны'))}
          </TextPromo>
          <Space size={24} />
          <Href
            href={mapLink}
            className={cls.mapImage}
            target="_blank"
            rel="noreferrer"
            linkType="search"
            onClick={() => sendEvent(EventType.MainCartPUPT)}
          ></Href>
        </div>
      </div>
    </div>
  )
}
